// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var UpdateFacebookMappingResponse_UpdateFacebookMappingResult;
(function (UpdateFacebookMappingResponse_UpdateFacebookMappingResult) {
    UpdateFacebookMappingResponse_UpdateFacebookMappingResult["OK"] = "OK";
    UpdateFacebookMappingResponse_UpdateFacebookMappingResult["UNAUTHORIZED_USER_FOR_FB_MANAGED_PAGE"] = "UNAUTHORIZED_USER_FOR_FB_MANAGED_PAGE";
})(UpdateFacebookMappingResponse_UpdateFacebookMappingResult || (UpdateFacebookMappingResponse_UpdateFacebookMappingResult = {}));
export var UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index;
(function (UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index) {
    UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index[UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index["OK"] = 0] = "OK";
    UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index[UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index["UNAUTHORIZED_USER_FOR_FB_MANAGED_PAGE"] = 1] = "UNAUTHORIZED_USER_FOR_FB_MANAGED_PAGE";
})(UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index || (UpdateFacebookMappingResponse_UpdateFacebookMappingResult_index = {}));
export const FacebookReviewsService = {
    GetFacebookReviewDetailById(fn, req) {
        try {
            fm.validateUrlParam(req["encodedReviewId"], "encodedReviewId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/facebook-reviews/v1/reviews/${req["encodedReviewId"]}?${fm.renderURLSearchParams(req, ["encodedReviewId"])}`, { method: "GET" });
    },
    /**
     * Fetches integration information for locations.
     */
    ListFacebookMappings(fn, req) {
        return fn(`/reviews/facebook-reviews/v1/reviews/mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Creates Facebook integration and access token by fetching page and creating mapping.  If missing, subscribes to webhook events.
     * Creates solicitation URL setting.
     */
    SetFacebookMapping(fn, req) {
        return fn(`/reviews/facebook-reviews/v1/reviews/mapping`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Rotates facebook access token on mapping.  If missing, subscribes to webhook events.
     */
    UpdateFacebookMapping(fn, req) {
        return fn(`/reviews/facebook-reviews/v1/reviews/mapping`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Removes Facebook integration for location.
     */
    DeleteFacebookMapping(fn, req) {
        return fn(`/reviews/facebook-reviews/v1/reviews/mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * Update setup state of Facebook integration.
     */
    UpdateReviewsSetupState(fn, req) {
        return fn(`/reviews/facebook-reviews/v1/reviews/mapping`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Fetches Facebook Business Pages associated with user.
     */
    ListFacebookPages(fn, req) {
        return fn(`/reviews/facebook-reviews/v1/pages?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
